// extracted by mini-css-extract-plugin
export default {"groupListWrapper":"pre-approved-list_groupListWrapper__X9KYo","groupListDate":"pre-approved-list_groupListDate__myoTm"};